import React from 'react'

import { ButtonClean } from '@fourthwall/components'
import { type OrderGroupedDetails } from '@modules/Dashboard/pages/Contributions/pages/Orders/pages/Order/Order.types'
import { reverse, routing } from '@utils/routing'

import * as S from './ProductItemGroupedDetails.styled'

type ProductItemGroupedDetailsProps = {
  groupedDetails: OrderGroupedDetails
}

export const ProductItemGroupedDetails = ({ groupedDetails }: ProductItemGroupedDetailsProps) => {
  return (
    <S.Container>
      Purchased in{' '}
      <ButtonClean
        appearance="secondary"
        label={groupedDetails.groupTypeName}
        to={reverse(routing.products.bundle.bundleId.self, {
          bundleId: groupedDetails.groupTypeId,
        })}
      />
    </S.Container>
  )
}
